import {ApolloClient, InMemoryCache, createHttpLink} from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import config from '../../config'

export const httpLink = createHttpLink({
  uri: config.saleor.apiUrl,
})

export function setAuthToken(token?: string) {
  if (token) {
    localStorage.setItem('jwt', token)
  } else {
    localStorage.removeItem('jwt')
  }
}

export const authLink = setContext((_, context) => {
  const authToken = localStorage.getItem('jwt')
  if (authToken) {
    return {
      ...context,
      headers: {
        ...context.headers,
        Authorization: authToken ? `JWT ${authToken}` : null,
      },
    }
  }
  return context
})

const cache = new InMemoryCache({
  typePolicies: {
    Checkout: {
      keyFields: ['id'],
      fields: {
        lines: {
          merge(_, incoming) {
            return incoming
          }
        }
      }
    }
  }
})

export const saleorClient = new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
})
